import { DeleteModalController } from '~extension/web2print/controller/DeleteModalController';
import { DownloadModalController } from '~extension/web2print/controller/DownloadModalController';
import { DuplicateModalController } from '~extension/web2print/controller/DuplicateModalController';
import { MessageModalController } from '~extension/web2print/controller/MessageModalController';
import { MyFilesModalController } from '~extension/web2print/controller/MyFilesModalController';
import { SapExportModalController } from '~extension/web2print/controller/SapExportModalController';
import useJobActions from '~extension/web2print/controller/useJobActions';
import { JobList } from '~extension/web2print/model/JobList';
import { ClientJobsTable } from '~extension/web2print/view/JobList/ClientJobsTable';

export function JobOverview({
  jobList,
  jobStatus,
  isLoading,
}: {
  jobList: JobList;
  jobStatus: string;
  isLoading: boolean;
}) {
  const {
    idWeb2Print,
    idClient,
    myFilesJob,
    downloadJob,
    closeDownload,
    closeWeb2Print,
    idDelete,
    closeDelete,
    sapExportJob,
    closeSapExport,
    message,
    closeMessage,
    ...jobActions
  } = useJobActions();

  if (isLoading) {
    return <div className="loading"></div>;
  }

  return (
    <div>
      {jobList.clients.map(client => {
        if (client.jobs.length === 0) {
          return (
            <>
              <h3>{client.name}</h3>
              <div className="bg-white p-5">
                <p>
                  Your task list is empty. Choose an existing Web2Print Template out of our Media Library and edit it
                  right now.
                </p>
              </div>
            </>
          );
        } else return <ClientJobsTable key={client.id} client={client} jobActions={jobActions} />;
      })}
      <DuplicateModalController assetId={idWeb2Print} onClose={closeWeb2Print} />
      <DownloadModalController downloadJob={downloadJob} onClose={closeDownload} />
      <MyFilesModalController myFilesJob={myFilesJob} onClose={closeDownload} />
      <DeleteModalController documentId={idDelete} clientId={idClient} onClose={closeDelete} jobStatus={jobStatus} />
      <SapExportModalController job={sapExportJob} onClose={closeSapExport} />
      <MessageModalController message={message} onClose={closeMessage} />
    </div>
  );
}
